<template>
  <section v-if="isGetRequestPending" class="edit-rule">
    <p-loading />
  </section>
  <section v-else class="edit-rule">
    <header>
      <h1>Edit Rule</h1>
      <div class="action-wrapper">
        <p-button v-if="$hasPermission('templates')" color="secondary" @click="confirmDelete">Delete</p-button>
      </div>
    </header>
    <p-edit-rule-form :is-request-pending="isUpdateRequestPending" :is-request-failed="isUpdateRequestFailed" :item="item" @submit="update" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditRuleForm from './_CreateOrEdit';
import Loading from '@/components/common/Loading';
import Button from './../common/Button';

export default {
  components: {
    'p-edit-rule-form': CreateOrEditRuleForm,
    'p-loading': Loading,
    'p-button': Button
  },
  computed: {
    ...mapState({
      item: s => s.rules.item,
      isGetRequestPending: s => s.rules.isGetRequestPending,
      isUpdateRequestPending: s => s.rules.isUpdateRequestPending,
      isUpdateRequestFailed: s => s.rules.isUpdateRequestFailed
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('rules/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('rules/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Rule was updated.`
        });
        this.$router.push({ path: `/rules/` });
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    },
    async confirmDelete() {
      const { id, name } = this.item;

      const confirmResult = await this.$confirm({
        title: 'Delete rule?',
        message: `Are you sure you want to delete rule '${name}'?\n\nThis action can't be undone.`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock();
      try {
        await this.$store.dispatch('rules/delete', id);

        this.$toast.success({
          title: 'Rule deleted',
          message: `Rule '${name}' (${id}) was successfully deleted.`
        });
        this.$router.push({ path: `/rules` });
      } catch (e) {
        this.$toast.error({
          title: 'Failed to delete rule',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-rule {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
    position: relative;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }

  .action-wrapper {
    position: absolute;
    right: 0rem;
    top: 50%;
    transform: translateY(-50%);

    button {
      margin-left: 1rem;
    }
  }
}
</style>
